export default __webpack_public_path__ + "static/media/empty-stage.e4f3d89d.png";